import * as React from "react"
import * as Immutable from 'immutable'
import SimpleFormat from "../../../utils/SimpleFormat";
import { BooleansOf } from "../../../utils/types";
import { snakeCase } from "lodash";
import { RentalAdvert, RentalAdvertTranslation } from "../../../types/types";
import BooleanList from "../../shared/advert/BooleanList";
import { ActivitiesRentalBooleans } from "../../../advert_detail/booleans";
import ReadMore from "../../shared/advert/ReadMore";

type Props = {
  advert: RentalAdvert
  translation: RentalAdvertTranslation
}

export default (props: Props) : JSX.Element => (
  !!props.translation && props.translation.remarks ? <>
    <div className="content-part">
      <h3>
        {I18n.t('rental_adverts.description.remarks')}
      </h3>
      <div>
        <div className="description">
          <ReadMore height={180}>
            <SimpleFormat
              text={props.translation.remarks}
            />
          </ReadMore>
        </div>
      </div>
    </div>
    <hr />
  </> : <></>
)
